import Modal from "react-bootstrap/Modal";
import { FaRegCommentDots, FaBullseye, FaGift } from "react-icons/fa";

const AboutClubModal = ({ show, onClose, clubTitle, hostName }) => (
  <Modal show={show} onHide={onClose} centered className="lpc-about">
    <Modal.Body className="p-4">
      <p className="lpc-about__eyebrow">Welcome</p>
      <h2 className="lpc-about__title">Listening, but more.</h2>
      <p className="lpc-about__sub">
        This is <strong>{clubTitle}</strong>. Each episode turns into something to think
        through and try for yourself
        {hostName ? <>, plus a direct line to the podcaster, <strong>{hostName}</strong>, if it means something.</> : "."}
      </p>

      {[
        { Icon: FaRegCommentDots, h: "What it is", p: "A space built around one episode at a time. Discussion prompts to reflect on, and a set of insights to try on your own." },
        { Icon: FaBullseye, h: "What you do", p: "Listen and then pick insights that fit where you are. Try them. Share in the thread if you want to, or keep them entirely to yourself." },
        { Icon: FaGift, h: "What you get", p: "A structured way to turn six episodes into real practice, a direct line to the podcaster when something lands, and a record of what you tried along the way." },
      ].map(({ Icon, h, p }) => (
        <div className="lpc-about__card" key={h}>
          <span className="lpc-about__icon"><Icon aria-hidden="true" /></span>
          <div><h3>{h}</h3><p>{p}</p></div>
        </div>
      ))}

      <div className="text-end mt-3">
        <button type="button" className="lpc-btn-accent" onClick={onClose}>Got it!</button>
      </div>
    </Modal.Body>
  </Modal>
);

export default AboutClubModal;
